<template>
  <v-container fluid>
    <PageTitle icon="fal fa-fw fa-cut">
      Email Snippets
      <template v-slot:buttons>
        <v-btn :to="{name: `${$root.routePrefix}.snippet.create`}"
               color="primary">
          New Snippet
        </v-btn>
      </template>
    </PageTitle>

    <v-alert type="info">
      <h3>
        What is a Snippet?
      </h3>
      A snippet is a short block text you write and can then paste into emails. They are only visible to you.
    </v-alert>

    <template v-if="busy">

    </template>
    <template v-else>
      <p v-if="snippets.length === 0">
        You don't have any snippets yet.
        <router-link :to="{name: `${$root.routePrefix}.snippet.create`}">Add one now</router-link>
        .
      </p>
      <template v-for="snippet in snippets">
        <snippet-card :snippet="snippet"
                      :key="snippet.id"
                      class="mb-4"
                      @deleted="fetchData">
        </snippet-card>
      </template>
    </template>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {orderBy} from 'lodash';
import snippetService from '../../services/snippetService';
import SnippetCard from "./components/SnippetCard";
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, SnippetCard},
  data() {
    return {
      busy: false,
      snippets: [],
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ])
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      const form = { // MLD-39697
        user_id: this.user.id,
      }
      snippetService.getSnippets(form)
        .then(data => {
          this.snippets = orderBy(data, ['created_at', 'slug'], ['desc', 'asc']);
        })
        .finally(() => {
          this.busy = false;
        })
    },
  },
}
</script>
